<template>
  <div>
    <div class="styleSet">
      <div class="blueBackView">
        操作说明：<br>
        提交银行卡信息后，银行会向您的{{ labelNames.isMaintenance}}银行卡转入小于等于0.5元的随机金额，并短信通知到经办人手机号，您查看后，需将收到的金额大小，在下一页上回填。银行验证通过后，完成{{labelNames.isMaintenance}}账户绑定。
      </div>
    </div>
    <div class="styleSet">
      <el-form style="width: 90%;" :rules="step1Rules" :label-width="labelWidth+'px'" :model="step1Form" inline  ref="step1Form">
        <el-col :span="12">
          <el-form-item :label="labelNames.accountIdName" prop="accountId">
            <div>{{step1Form.accountId}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="labelNames.merchantNameFn" prop="merchantName">
            <div>{{step1Form.merchantName}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="统一社会信用代码证号:" prop="licenceNo">
            <div>{{step1Form.licenceNo}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="bankCardNo" :label="labelNames.bankCardNoName">
            <el-input
              placeholder="请输入"
              v-model="step1Form.bankCardNo"
              v-number:integer.noTrim="50"
              clearable>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="bankShortName" label="开户行名称:">
            <el-select v-model="step1Form.bankShortName" @change="handleSelectChange" filterable clearable placeholder="请选择">
              <el-option
                v-for="option in bankIdList"
                :key="option.id"
                :label="option.bankShortName"
                :value="option.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="contactMobile" label="经办人手机号:">
            <el-input
              placeholder="请输入"
              v-model="step1Form.contactMobile"
              v-number:integer="11"
              clearable>
            </el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </div>
</template>
<script>

import { bankCardPreSign, bankList } from '@/api/financeApi/walletWithhold'
import config from './config'
import { validateMobile } from '@/utils/validate'

export default {
  props: {
    stepsParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const {
      labelNames,
      pageType,
    } = config.call(this)
    return {
      // eslint-disable-next-line vue/no-unused-properties
      pageType,
      labelNames,
      labelWidth: 175,
      selectedOption: '', // 获取保存开户行名称
      bankIdList: [],
      // eslint-disable-next-line vue/no-unused-properties
      accountId: '',
      // eslint-disable-next-line vue/no-unused-properties
      merchantName: '',
      // eslint-disable-next-line vue/no-unused-properties
      licenceNo: '',
      // eslint-disable-next-line vue/no-unused-properties
      origin: '',
      step1Form: {
        accountId: '',
        merchantName: '',
        licenceNo: '',
        bankCardNo: '',
        bankShortName: '',
        contactMobile: '',
      },
      step1Rules: {
        bankShortName: [
          { required: true, message: '请选择开户行名称', trigger: 'change' },
        ],
        bankCardNo: [
          { required: true, message: pageType === 1 ? '请填写付款银行卡卡号' : '请填写提现银行卡卡号', trigger: 'blur' },
        ],
        contactMobile: [
          { required: true, message: '请填写经办人手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: ['change', 'blur'] },
        ],
      },
    }
  },
  created() {
    this.getBankList()
  },
  methods: {
    handleSelectChange(value) {
      if (!value) {
        this.selectedOption = ''
        return
      }
      const selectedOption = this.bankIdList.find((option) => option.id === value)
      // 获取保存开户行名称
      this.selectedOption = selectedOption.bankShortName
    },
    // 接收第一步资金收款户ID、资金收款户公司主体全称、统一社会信用代码证号数据
    // eslint-disable-next-line vue/no-unused-properties
    receiveData(val) {
      this.step1Form.accountId = val.accountId
      this.step1Form.merchantName = val.merchantName
      this.step1Form.licenceNo = val.licenceNo
    },
    async getBankList() {
      try {
        const { code, data } = await bankList()
        if (code === 1) {
          this.bankIdList = data
          // 第二步返回第一步接收数据
          if (this.stepsParams) {
            this.step1Form = this.stepsParams
            // 保存开户行名称
            this.selectedOption = this.stepsParams.selectedOption
            // 删除第二步中的开户行名称
            // eslint-disable-next-line
            delete this.stepsParams.selectedOption
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    nextStep() {
      this.$refs.step1Form.validate(async (valid) => {
        if (valid) {
          try {
            // 银行卡预签约-第一步填写银行卡信息
            const { data } = await bankCardPreSign({
              accountId: this.step1Form.accountId,
              bankCardNo: this.step1Form.bankCardNo,
              bankId: this.step1Form.bankShortName,
              contactMobile: this.step1Form.contactMobile,
              channelType: 6,
            })

            switch (data) {
              case 0:
              // this.$message.error(msg)
                this.$emit('failed')
                break
              case 1: {
                const dictionaryData = {
                  ...this.step1Form,
                  selectedOption: this.selectedOption, // 开户行名称
                }
                this.$refs.step1Form.resetFields()
                this.$emit('success', dictionaryData)
                break
              }
              case 2:
                this.$message.success('操作成功')
                this.$router.back()
                break
            }
          } catch (error) {
            this.$emit('failed')
          }
        } else {
          this.$emit('failed')
          this.$message.error('请填写必填项，并输入正确的信息格式')
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.styleSet{
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
}
.blueBackView{
  width: 90%;
  background-color: #ECF3FF;
  color: #006AF5;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 20px;
  border-radius: 5px;
}
</style>

